export const TABLEAU_DISPLAY_NAME = {
    BUSINESS_MODEL : 'Business model (agrid business model)',
    COUNTRY_OF_ORIGIN : 'Country of origin',
    COUNTRY_OR_TERRITORY : 'Countries and Territories (agrid country)',
    FOOD_VALUE_CHAIN : 'Food value chain (agrid fvc)',
    FOUR_BETTERS: 'Four betters (agrid four betters)',
    MATURITY: 'Maturity1',
    ORGANIZATION_TYPE : 'Organization type',
    SGDS: 'SDGs (agrid sdg)',
    TECHNOLOGY : 'Technology (agrid technology)',
    THEME : 'Theme (agrid theme)',
    TYPE : 'Entry Type',
    USE_CASE : 'Use case (agrid use case)',
    USERS : 'Users',
}